export default __webpack_public_path__ + "static/media/sendy-negative.566e0143.svg";